import React, { useCallback } from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../../common/list/FilterToggleGroup';

const projectStatus = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: '0', label: '수주품의', color: 'secondary' },
  { id: 2, value: '1', label: '발주', color: 'success' },
  { id: 3, value: '2', label: '세금계산서', color: 'error' },
  { id: 4, value: '3', label: '채권', color: 'primary' },
];

// 단계 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
//착수보고/분석설계/구축(이행)/완료(검수)
//22.12.3.  수주 - 발주 - 세금계산서 - 채권
const ProjectStatusList = ({ filters, onFilters }) => {
  const handleFilterStatus = useCallback(
    (value) => {
      onFilters('searchGrade', value);
    },
    [onFilters],
  );

  return (
    <FilterToggleRow>
      <FilterToggleGroup label="단계" options={projectStatus} value={filters?.searchGrade} onChange={handleFilterStatus} />
    </FilterToggleRow>
  );
};

export default ProjectStatusList;
